<template>
  <el-dialog
    :title="$t('shopSetting.editSetting')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form 
      :model="editShopSettingInfo" 
      :rules="rules" 
      ref="editForm"
      label-width="120px"
    >
      <el-form-item 
        :label="$t('shopSetting.settingName')" 
        prop="settingName"
      >
        <el-input
          v-model="editShopSettingInfo.settingName"
          disabled
          :placeholder="$t('shopSetting.inputSettingNameRequired')"
        ></el-input>
      </el-form-item>

      <el-form-item 
        :label="$t('shopSetting.settingKey')" 
        prop="settingKey"
      >
        <el-input
          v-model="editShopSettingInfo.settingKey"
          disabled
          :placeholder="$t('shopSetting.inputSettingKeyRequired')"
        ></el-input>
      </el-form-item>

      <el-form-item 
        :label="$t('shopSetting.settingValue')" 
        prop="settingValue"
      >
        <el-input
          v-model="editShopSettingInfo.settingValue"
          :placeholder="$t('shopSetting.inputSettingValueRequired')"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('shopSetting.remark')">
        <el-input
          type="textarea"
          v-model="editShopSettingInfo.remark"
          :placeholder="$t('shopSetting.inputRemarkOptional')"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button 
        type="primary" 
        @click="editShopSetting"
      >{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { updateShopSetting } from '@/api/goods/shopSettingApi'

export default {
  name: 'EditShopSetting',
  data() {
    return {
      dialogVisible: false,
      editShopSettingInfo: {
        ssId: '',
        shopId: '',
        settingName: '',
        settingType: '',
        settingKey: '',
        settingValue: '',
        remark: ''
      },
      rules: {
        settingName: [
          { required: true, message: this.$t('shopSetting.settingNameRequired'), trigger: 'blur' }
        ],
        settingKey: [
          { required: true, message: this.$t('shopSetting.settingKeyRequired'), trigger: 'blur' }
        ],
        settingValue: [
          { required: true, message: this.$t('shopSetting.settingValueRequired'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('shopSetting.remarkRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(row) {
      this.editShopSettingInfo = { ...row }
      this.editShopSettingInfo.shopId = getShopId()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    handleClose() {
      this.$refs.editForm.resetFields()
      this.editShopSettingInfo = {
        ssId: '',
        shopId: '',
        settingName: '',
        settingType: '',
        settingKey: '',
        settingValue: '',
        remark: ''
      }
    },
    async editShopSetting() {
      this.$refs.editForm.validate(async valid => {
        if (!valid) return

        try {
          await updateShopSetting(this.editShopSettingInfo)
          this.$message.success(this.$t('common.saveSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('更新失败:', error)
        }
      })
    }
  }
}
</script>